import { useSelector } from 'react-redux'
import { jt, t } from 'ttag'
import { Link } from 'react-router-dom'

import LoadingIndicator from '../../components/LoadingIndicator'
import { useInitDispatch, useTitleChange } from '../../util/hooks'
import { compareMajors } from '../../actions/majors'

const MajorComparison = props => {
  useTitleChange(t`Instructional Program Comparison`)
  useInitDispatch(compareMajors(props.location.query.cip), [props.location.query.cip])

  const { error, fluidContainer = false } = props
  const comparisons = useSelector(
    state => state.college.majorComparison.result?.comparisons
  )

  if (!comparisons) {
    return <LoadingIndicator newSiteLook={dynamicValues.newSiteLook} />
  }

  if (error) {
    return (
      <div className="container">
        <div className="alert alert-warning" role="alert">
          <h3>{error}</h3>
        </div>
      </div>
    )
  }

  return (
    <div className={fluidContainer ? 'container-fluid' : 'container'}>
      <table id="comparison" className="tbl">
        <thead>
          <tr>
            <th className="comparison-heading">
              <span className="sr-only">{t`Comparison Attribute`}</span>
            </th>
            {(comparisons || []).map(r => (
              <th className="occupation-title">
                <Link
                  to={r?.url}
                  style={{ fontWeight: 'bold' }}
                  className="occupation-link regular-match">
                  {r?.title}
                </Link>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr className="odd">
            <th scope="row" className="comparison-heading">{t`Number of Graduates`}</th>
            {(comparisons || []).map(r => (
              <td className="occupation-title">{r?.numCompletions?.toLocaleString()}</td>
            ))}
          </tr>

          <tr className="even">
            <th
              scope="row"
              className="comparison-heading">{t`Projected Annual Job Openings *`}
            </th>
            {(comparisons || []).map(r => (
              <td className="occupation-title">{r?.annualOpenings?.toLocaleString()}</td>
            ))}
          </tr>
          <tr className="odd">
            <th scope="row" className="comparison-heading">{t`Average Salary *`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`salary${idx}`} className="occupation-title">
                {data?.avgWages?.toLocaleString('en', {
                  style: 'currency',
                  currency: 'USD',
                  maximumFractionDigits: 0,
                  minimumFractionDigits: 0
                })}
              </td>
            ))}
          </tr>
          <tr className="even">
            <th scope="row" className="comparison-heading">{t`Colleges Offering`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`offering${idx}`} className="occupation-title">
                <Link to={data?.collegeSearchUrl}>
                  {data?.numberOfInstitutionsOffering}
                </Link>
              </td>
            ))}
          </tr>
          <tr className="odd">
            <th scope="row" className="comparison-heading">{t`What you can become`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`future1${idx}`} className="possible-occs vatop">
                <ul className="fa-ul">
                  {data?.occupations?.map((occ, idx2) => (
                    <li key={`future2${idx2}`}>
                      <i aria-hidden="true" className="fa-li fal fa-briefcase"></i>
                      <Link to={occ.url} className="occupation-link regular-match title">
                        {occ.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </td>
            ))}
          </tr>
        </tbody>
        <tfoot>
          <tr className="even">
            <th></th>
            {(comparisons || []).map((data, idx) => (
              <th key={`prog${idx}`} className="profile-link">
                <Link to={data?.url} className="submit">
                  {t`View Program`}
                </Link>
              </th>
            ))}
          </tr>
        </tfoot>
      </table>
      <div className="disclaimer">
        <br />
        {jt`* The number of job openings and the average salary are computed by using the average salary of typical jobs which require the specified major. The wages you can expect will be determined by the occupation you end up with, not by your specific major.`}
      </div>
    </div>
  )
}

export { MajorComparison }
